module.exports = __webpack_public_path__ + "img/76260.cab0f006.svg";